import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import logoBlick from '@assets/images/logo-blick.svg'
import { desktopCSS, mobileCSS, tabletCSS } from '@measures/responsive'
import Blink from '@components/Blink'
import config from '@config'
import useTrackingUtils from '../useTrackingUtils'

const {
  backend: { rootUrl },
} = config

const StyledLogo = styled.img`
  ${desktopCSS(css`
    height: 60px;
    width: auto;
  `)}

  ${tabletCSS(css`
    height: 60px;
    width: auto;
  `)}
  
  ${mobileCSS(css`
    height: 48px;
    width: auto;
  `)}
`

const Logo: FunctionComponent = () => {
  const { navbarClickTrackingFn } = useTrackingUtils({
    title: 'Blick logo',
    url: rootUrl,
  })
  return (
    <Blink href={rootUrl} onClick={navbarClickTrackingFn}>
      <StyledLogo
        width="300"
        height="132"
        src={logoBlick}
        alt="Blick logo"
        loading="lazy"
      />
    </Blink>
  )
}

export default Logo
